<script setup lang="ts">
  import ChangelogModal from '@/components/modals/ChangelogModal.vue';
  import { useModal } from '@/composition/use-modal';

  const modal = useModal();

  const openChangelog = () => {
    modal.show(
      ChangelogModal,
      {},
      {
        name: 'changelog',
        classes: 'dialog--height-limit',
        adaptive: true,
        height: 'auto',
        width: 700,
        scrollable: true,
        maxWidth: window.innerWidth * 0.95,
      }
    );
  };
</script>

<template>
  <v-card class="announcement-card">
    <v-card-title class="card-title">
      <v-icon left>mdi-bullhorn</v-icon>
      Últimas novedades
    </v-card-title>
    <v-card-text>
      <v-btn
        color="success"
        @click="openChangelog"
        block
        class="font-weight-light"
      >
        <v-icon left>mdi-new-box</v-icon>
        24/07 - Plano de mesas!
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">
  .announcement-card {
    @apply tw-bg-gradient-to-r tw-from-green-50 tw-to-emerald-50;
    @apply tw-rounded-2xl tw-shadow-sm #{!important}; // DO NOT FIX THIS LINTER ERROR

    .card-title {
      @apply tw-text-lg tw-font-medium tw-text-green-800;
    }
  }
</style>
